exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TimeAggregationFilter>* {\n  float: right;\n  text-transform: capitalize;\n}\n\n.TimeAggregationFilter select {\n  background-color: #fff;\n  border: 1px solid #bac2c7;\n  color: #777;\n  font-size: 16px;\n  height: 40px;\n  line-height: 40px;\n  padding: 0 10px;\n  text-align: left;\n  width: 115px;\n}\n\n.TimeAggregationFilter label {\n  color: #777;\n  font-size: 16px;\n  line-height: 40px;\n  margin-right: 5px;\n  padding: 0;\n}\n\n.TimeAggregationFilter .disableTimeFilter{\n  opacity: 0.5;\n}\n", ""]);

// exports
